import React from 'react';
import './LoadingSpinner.css';

function LoadingSpinner({ size = 'medium', message = null, fullScreen = false }) {
    const content = (
        <div className={`loading-spinner ${fullScreen ? 'fullscreen' : ''}`}>
            <div className={`spinner spinner-${size}`}></div>
            {message && <p className="loading-message">{message}</p>}
        </div>
    );

    return content;
}

export default LoadingSpinner;
